/*
  Slide variant for the Carousel component.
  This slide type contains a heading and marketing text.
*/

import { PropTypes } from "react";

const MarketingSlide = (props) => (
  <div className="gr-col-12 gr-col-md-9 marketingSlide">
    <div className="marketingSlide__contents">
      <h3 className="gr-h3 marketingSlide__heading">{props.heading}</h3>
      <div className="marketingSlide__text">{props.text}</div>
    </div>
  </div>
);

MarketingSlide.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default MarketingSlide;
